import React , { useReducer } from 'react' ;

import CartContext from './cart-contex';


const defaultCartState = {
    items: [] ,
    totalAmount: 0 
}

function cartReducer(state , action) {

    if(action.type === 'ADD') {
        const newTotalAmount = state.totalAmount + action.item.price * action.item.amount ;

        const existingCartItemIndex = state.items.findIndex(item => item.id === action.item.id) ;
        const existingCartItem = state.items[existingCartItemIndex];

        let updatedItems ;

        if(existingCartItem) {
            let updatedItem = {
                ...existingCartItem , 
                amount: existingCartItem.amount + action.item.amount
            } ;
            updatedItems = [...state.items] ;
            updatedItems[existingCartItemIndex] = updatedItem ;
        } else {
             updatedItems = state.items.concat(action.item) ;
        }

        return {
            items: updatedItems ,
            totalAmount: newTotalAmount
        }
    }

        if(action.type === 'REMOVE') {
            const existingCartItemIndex = state.items.findIndex(item => item.id === action.id) ;

            const existingItem = state.items[existingCartItemIndex];

            const updatedTotalAmount = state.totalAmount - existingItem.price ;

            let updatedItems ;

            if(existingItem.amount === 1) {
                updatedItems = state.items.filter(item => item.id !== action.id)
            }else {
                const updatedItem = {...existingItem , amount: existingItem.amount - 1} ;
                updatedItems = [...state.items] ;
                updatedItems[existingCartItemIndex] = updatedItem ;
            }

            return {
                items: updatedItems ,
                totalAmount: updatedTotalAmount
            }

        }

    return defaultCartState ;
}



function CartProvider(props) {

    const [cartState , dispathCartAction] = useReducer(cartReducer , defaultCartState) ;

    function addItemToCartHandler(item) {
        dispathCartAction({type: 'ADD' , item: item})
    } ;

    function removeItemFromCartHandler(id) {
        dispathCartAction({type: 'REMOVE' , id: id})
    } ;

    const cartContext = {
        items: cartState.items ,
        totalAmount: cartState.totalAmount ,
        addItem: addItemToCartHandler ,
        removeItem: removeItemFromCartHandler
    }

  return (
    <CartContext.Provider value={cartContext}>
        {props.children}
    </CartContext.Provider>
)}

export default CartProvider ;